<template>
	<JBox class="s-w-full">
		<JBox class="block">
			<!-- Label -->
			<JLabel :for="name" class="s-block s-text-gray-700 s-leading-tight s-font-semibold s-text-sm">
				{{ label }}
			</JLabel>

			<!-- Subheadline -->
			<JText class="s-text-gray-500 s-text-sm" v-if="subheadline">{{ subheadline }}</JText>

			<slot />
		</JBox>

		<!-- Description -->
		<JBox v-if="description">
			<JText class="s-text-gray-500 s-text-sm">{{ description }}</JText>
			<slot name="description"></slot>
		</JBox>

		<!-- Component for input -->
		<Component :is="componentName" :id="name" v-bind="{ ...$props, ...$attrs }" v-on="$listeners" class="s-mt-1" />

		<!-- TODO: validation error messages -->

		<slot name="bottom"></slot>
	</JBox>
</template>

<script>
export default {
	props: {
		name: { type: String, required: true },

		// Component to be rendered
		// If component is not registered globally, you acn pass the component object
		componentName: { type: [String, Object], required: true },

		value: { required: true },
		options: { type: Array, required: false },
		label: { type: String },
		subheadline: { type: String },
		placeholder: { type: String },
		description: { type: String }
	}
}
</script>
